import React, { useState, useEffect } from "react";
import axios from "axios";

const FOOTER_PATH = "static/footer/";

const Footer = () => {
  const [hidden, setHidden] = useState(false);
  const [footerPage, setFooterPage] = useState("");
  const currUrl = window.location;
  const baseUrl = currUrl.protocol + "//" + currUrl.host + currUrl.pathname;
  const footerPageUrl = `${baseUrl}${
    baseUrl.slice(-1) === "/" ? "" : "/"
  }${FOOTER_PATH}index.html`;

  useEffect(() => {
    axios
      .get(footerPageUrl)
      .then((res) => {
        setFooterPage(res.data);
      })
      .catch(function(err) {
        setHidden(true);
      });
  }, []);

  return hidden ? (
    <div />
  ) : (
    <iframe
      title={"homePageIframeTitle"}
      id={"homePageIframeId"}
      srcDoc={footerPage}
      style={{ border: 0, width: "100%" }}
    />
  );
};

export default Footer;
